

document.addEventListener('DOMContentLoaded', function() {
    const rightArrow = document.querySelector('.cstm-mbl-arrow-right');
    const leftArrow = document.querySelector('.cstm-mbl-arrow-left');

    if (rightArrow) {
        rightArrow.addEventListener('click', function() {
            const slickNext = document.querySelector('#shopify-section-template--22437303779656__image_with_products_jzpXBF .slick-next');
            if (slickNext) slickNext.click();
        });
    }

    if (leftArrow) {
        leftArrow.addEventListener('click', function() {
            const slickPrev = document.querySelector('#shopify-section-template--22437303779656__image_with_products_jzpXBF .slick-prev');
            if (slickPrev) slickPrev.click();
        });
    }

  
});



document.addEventListener('DOMContentLoaded', () => {
  if(document.getElementById('toggleButton')) {
  document.getElementById('toggleButton').addEventListener('click', function () {

      const truncateDesc = document.getElementById('truncateDescription');
      const fullDesc = document.getElementById('fullDescription');
      const button = this;
  
      if (button.innerText === "Read More") {
          button.innerText = "Read Less";
          truncateDesc.classList.remove('active');
          fullDesc.classList.add('active');
          truncateDesc.style.display = 'none';
          fullDesc.style.display = 'block';
      } else {
          button.innerText = "Read More";
          fullDesc.classList.remove('active');
          truncateDesc.classList.add('active');
          fullDesc.style.display = 'none';
          truncateDesc.style.display = 'block';
      }
  });
}
});





















